export interface StateAuthentication {
  jwtToken: string | null;
  // eslint-disable-next-line
  decodedJwtToken: null | { [key: string]: any } | string;
}

export class State implements StateAuthentication {
  public jwtToken = null;
  public decodedJwtToken = null;
}
